import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;

  > h2 {
    font-weight: 700;
    font-size: 2rem;
    margin-top: 3rem;
    color: #666666;
  }
`;

export const TemplatesTable = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-top: 24px;
  max-width: 80%;
  max-height: 50vh;
  overflow: auto;
`;

export const AttachFileButton = styled.div`
  min-width: 25%;
  margin-top: auto;

  > label {
    font-weight: 600;
    color: #606060;
    border-radius: 2rem;
    font-size: 1rem;
    padding: 0.75em 0;
    border: 2px solid #b6b6b6;
    margin: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    &#add-file-lbl {
      cursor: pointer;
    }
    &#disabled-file-btn {
      cursor: not-allowed;
    }
  }

  > label#file-name-lbl {
    padding: 0.75rem 1.5rem;
    min-width: 40%;
    > span {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > h6 {
        cursor: pointer;
        font-size: 1rem;
        color: #3241c1;
        font-weight: 600;
      }
      > h6:hover {
        opacity: 0.7;
        transition: linear 0.1s;
      }

      > svg {
        cursor: pointer;
      }
    }
  }

  input[type="file"] {
    display: none;
  }
`;

export const ErrorMessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 75vh;

  > h2 {
    width: 60%;

    text-align: center;

    color: #ff5252;
  }
`;
